import {createFrontendApisClient, type PropelAuthApi} from '@propelauth/frontend-apis';

let cachedClient: PropelAuthApi | null = null;

export function useFrontendApisClient(): PropelAuthApi {
  if (cachedClient) return cachedClient;
  const config = useRuntimeConfig().public;
  const authUrl = config.propelAuthUrl as string;
  cachedClient = createFrontendApisClient({authUrl, baseApiUrl: authUrl});
  return cachedClient;
}
